import { render, staticRenderFns } from "./LegalInfos.vue?vue&type=template&id=56d16130&scoped=true"
import script from "./LegalInfos.vue?vue&type=script&lang=js"
export * from "./LegalInfos.vue?vue&type=script&lang=js"
import style0 from "./LegalInfos.vue?vue&type=style&index=0&id=56d16130&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56d16130",
  null
  
)

export default component.exports